import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getInitials({ fullName }: { fullName: string }): string {
  if (!fullName) return "??";
  const names = fullName.trim().split(" ");
  if (names.length === 1) {
    return names[0].substring(0, 1).toUpperCase();
  }
  return (names[0][0] + names[names.length - 1][0]).toUpperCase();
}
